import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";

import { withTrack, withTrackProps } from "@dpdgroupuk/react-event-tracker";

import { NEW_USER_ANALYTICS } from "../../../../constants/analytics";
import { getPermittedIpAddress } from "../../../../features/customer/customer.selectors";
import { onConfirmCreateDPDUser } from "../../../../features/user/user.actions";
import { shouldShowLeavePrompt } from "../../../../features/user/user.selectors";
import { prepareRequiredCreateData } from "../../../../features/userDetailsForm/userDetailsForm.actions";
import { isCreateCustomerUserFormDirty } from "../../../../features/userDetailsForm/userDetailsForm.selector";
import { navigateToHome } from "../../../../router/navigation";
import MainUserForm from "../../components/MainUserForm/MainUserForm";

const mapStateToProps = (state, ownProps) => {
  const { customerId } = ownProps.match.params;
  return {
    formDirty: isCreateCustomerUserFormDirty(state),
    showPrompt: shouldShowLeavePrompt(state),
    permittedIpAddress: getPermittedIpAddress(customerId)(state),
  };
};

const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { id, customerId },
    },
  }
) => ({
  onCancel: () => navigateToHome(customerId),
  onConfirm: () => dispatch(onConfirmCreateDPDUser(id, customerId)),
  prepareData: () => dispatch(prepareRequiredCreateData(customerId)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTrack({
    loadId: NEW_USER_ANALYTICS.LOAD,
    interfaceId: NEW_USER_ANALYTICS.INTERFACE_ID,
  }),
  lifecycle({
    componentDidMount() {
      this.props.prepareData();
    },
  }),
  withTrackProps(() => ({
    onCancel: () => NEW_USER_ANALYTICS.CANCEL,
    onConfirm: () => NEW_USER_ANALYTICS.CONFIRM,
  }))
)(MainUserForm);
